import { useProjects } from "./use-projects"

/**
 * Returns the tenant ID as a number for API requests.
 * Gets tenantId from projects (Harpoon/Cloud Director).
 * The backend determines the tenant from the JWT token via Director API.
 * Defaults to 0 if no projects are available (matching C# backend default).
 */
export function useTenantIdNumber(): number {
  const { data: projects } = useProjects()

  // Get tenantId from first project (from Harpoon/Cloud Director)
  // Projects are already filtered by tenant based on the JWT token
  if (projects && projects.length > 0) {
    return projects[0].tenantId
  }

  return 0
}
